export class Email {
    $key: string;
    created_at: Date;
    sent_date: Date;
    sent_by: string;
    recipient_uid: string;
    subject: string;
    text: string;
  }
  